import React, { useState } from 'react';
import './TenToTheTopScorecard.css';

function TenToTheTopScorecard() {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [currentPoints, setCurrentPoints] = useState(1);
  const [totalScore, setTotalScore] = useState(0);
  const [jokerUsed, setJokerUsed] = useState(false);
  const [jokerUsedThisQuestion, setJokerUsedThisQuestion] = useState(false);
  const [gameOver, setGameOver] = useState(false);

  const handleCorrectAnswer = () => {
    const pointsToAdd = jokerUsedThisQuestion ? currentPoints * 2 : currentPoints;
    setTotalScore(totalScore + pointsToAdd);
    
    if (currentQuestion === 10) {
      setGameOver(true);
    } else {
      setCurrentQuestion(currentQuestion + 1);
      setCurrentPoints(currentPoints + 1); // Continue escalating from current points
      setJokerUsedThisQuestion(false);
    }
  };

  const handleIncorrectAnswer = () => {
    if (currentQuestion === 10) {
      setGameOver(true);
    } else {
      setCurrentQuestion(currentQuestion + 1);
      setCurrentPoints(1); // Reset to 1 point after wrong answer
      setJokerUsedThisQuestion(false);
    }
  };

  const handleJoker = () => {
    if (!jokerUsed && !jokerUsedThisQuestion) {
      setJokerUsed(true);
      setJokerUsedThisQuestion(true);
    }
  };

  const resetGame = () => {
    setCurrentQuestion(1);
    setCurrentPoints(1);
    setTotalScore(0);
    setJokerUsed(false);
    setJokerUsedThisQuestion(false);
    setGameOver(false);
  };

  if (gameOver) {
    return (
      <div className="game-over">
        <h1>Game Over!</h1>
        <h2>Final Score: {totalScore}</h2>
        <button onClick={resetGame} className="reset-button">
          Play Again
        </button>
        <div className="footer">
          <a 
            href="https://www.barneyplantertrust.org" 
            target="_blank" 
            rel="noopener noreferrer"
            className="trust-link"
          >
            <img 
              src="/assets/BarneyPlanterTrust.png" 
              alt="Barney Planter Trust" 
              className="trust-image"
            />
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="ten-to-the-top">
      <header>
        <h1>Ten to the Top Scorecard</h1>
      </header>

      <main className="game-area">
        <div className="score-display">
          <p>Total Score: {totalScore}</p>
        </div>
        <div className="question-display">
          <h2>Question {currentQuestion}</h2>
          <p>This question is worth {currentPoints} point{currentPoints > 1 ? 's' : ''}</p>
          {jokerUsedThisQuestion && <p className="joker-active">🎯 JOKER ACTIVE - Double Points!</p>}
        </div>

        <div className="answer-buttons">
          <button 
            onClick={handleCorrectAnswer} 
            className="correct-button"
          >
            ✅ Correct Answer
          </button>
          <button 
            onClick={handleIncorrectAnswer} 
            className="incorrect-button"
          >
            ❌ Incorrect Answer
          </button>
        </div>

        <div className="joker-section">
          <button 
            onClick={handleJoker} 
            className="joker-button"
            disabled={jokerUsed}
          >
            {jokerUsed ? '🎯 Joker Used' : '🎯 Use Joker'}
          </button>
          <p className="joker-info">
            {jokerUsed ? 'Joker already used this game' : 'Double points for this question only'}
          </p>
        </div>
      </main>

      <div className="footer">
        <a 
          href="https://www.barneyplantertrust.org" 
          target="_blank" 
          rel="noopener noreferrer"
          className="trust-link"
        >
          <img 
            src="/assets/BarneyPlanterTrust.png" 
            alt="Barney Planter Trust" 
            className="trust-image"
          />
        </a>
      </div>
    </div>
  );
}

export default TenToTheTopScorecard;
